/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Removed_From_FavoritesInputs */

const en_removed_from_favorites = /** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removed from your favorites`)
};

const es_removed_from_favorites = /** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado de tus favoritos`)
};

const fr_removed_from_favorites = /** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retiré de vos favoris`)
};

const de_removed_from_favorites = /** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus deinen Favoriten entfernt`)
};

const id_removed_from_favorites = /** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dihapus dari favorit Anda`)
};

/** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */
const ja_removed_from_favorites = en_removed_from_favorites;

/** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */
const zh_removed_from_favorites = en_removed_from_favorites;

/** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */
const ar_removed_from_favorites = en_removed_from_favorites;

/** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */
const it_removed_from_favorites = en_removed_from_favorites;

/** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */
const ru_removed_from_favorites = en_removed_from_favorites;

/** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */
const pt_removed_from_favorites = en_removed_from_favorites;

/** @type {(inputs: Removed_From_FavoritesInputs) => LocalizedString} */
const ko_removed_from_favorites = en_removed_from_favorites;

/**
* | output |
* | --- |
* | "Removed from your favorites" |
*
* @param {Removed_From_FavoritesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const removed_from_favorites = /** @type {((inputs?: Removed_From_FavoritesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removed_From_FavoritesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_removed_from_favorites(inputs)
	if (locale === "es") return es_removed_from_favorites(inputs)
	if (locale === "fr") return fr_removed_from_favorites(inputs)
	if (locale === "de") return de_removed_from_favorites(inputs)
	if (locale === "ja") return ja_removed_from_favorites(inputs)
	if (locale === "zh") return zh_removed_from_favorites(inputs)
	if (locale === "ar") return ar_removed_from_favorites(inputs)
	if (locale === "id") return id_removed_from_favorites(inputs)
	if (locale === "it") return it_removed_from_favorites(inputs)
	if (locale === "ru") return ru_removed_from_favorites(inputs)
	if (locale === "pt") return pt_removed_from_favorites(inputs)
	return ko_removed_from_favorites(inputs)
});